/* @flow */

import { connect } from 'react-redux'

import type { RootState } from '../types'

import { selectHasCurrentUser } from '../stores/currentUser'
import Condition from './Condition'

type StateProps = {
  shouldRender: boolean,
}

function mapStateToProps(state: RootState): StateProps {
  return {
    shouldRender: selectHasCurrentUser(state),
  }
}

export default connect(mapStateToProps)(Condition)



// WEBPACK FOOTER //
// ./src/components/IfUser.js